var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_9570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86824 0C8.98352 0 11.5087 2.45229 11.5087 5.47713C11.5087 8.50197 8.98332 10.9541 5.86824 10.9541C2.75315 10.9541 0.227539 8.50197 0.227539 5.47713C0.227539 2.45229 2.75295 0 5.86824 0ZM14.876 0.320836C16.4337 0.320836 17.6964 2.62915 17.6964 5.47713H17.6966C17.6966 8.32436 16.4339 10.6334 14.8762 10.6334C13.3186 10.6334 12.0559 8.32436 12.0559 5.47713C12.0559 2.62989 13.3184 0.320836 14.876 0.320836ZM19.2356 0.857903C19.7833 0.857903 20.2275 2.92596 20.2275 5.47713C20.2275 8.02755 19.7835 10.0964 19.2356 10.0964C18.6877 10.0964 18.2439 8.02811 18.2439 5.47713C18.2439 2.92615 18.6879 0.857903 19.2356 0.857903Z",
    fill: "#4A687F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_9570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 11,
    fill: "white",
    transform: "translate(0.227539)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumFooter);
export default __webpack_public_path__ + "static/media/medium_footer.92672fec94928bb2149cdcb2e17dfe1f.svg";
export { ForwardRef as ReactComponent };